import type { LocationQuery } from 'vue-router'

/**
 * 諮詢模式旗標：broadband.html「我要諮詢」入口帶 ?consult=1 進入。
 * 注意：public/broadband.html 為靜態檔、無法 import 本常數，其 ?consult=1 需與此處同步維護。
 */
export const CONSULT_QUERY_KEY = 'consult'
export const CONSULT_QUERY_ON = '1'

/** 判斷本次導航是否為諮詢流程（只認網址明確帶的 ?consult=1，不看會殘留的 store.consultMode） */
export const isConsultQuery = (query: LocationQuery): boolean =>
  query[CONSULT_QUERY_KEY] === CONSULT_QUERY_ON
